import { GetServerSideProps } from 'next';
import { useEffect } from 'react';

import ProfileLayout from '@/components/app/profile/ProfileLayout';
import UpdateUserLayout from '@/components/app/profile/UpdateUser';
import Layout from '@/components/layout/LayoutWrapper';
import Loader from '@/components/Loader';
import { useAuth } from '@/context/auth/AuthProvider';
import { useAppLoadedState } from '@/hooks/store';
import { useRouterPush } from '@/hooks/utils/useRouterPush';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

import { messages } from '.';

const UpdateUser = () => {
	const appLoaded = useAppLoadedState();
	const { isLoading, isAuth0User } = useAuth();
	const routerPush = useRouterPush();

	// Redirecting must happen post-hydration: the Pages Router's SSR router instance
	// throws if `.push()` is invoked during the server render pass, and isAuth0User
	// is already known synchronously from SSR-seeded state, so this branch can be
	// taken on the very first (server) render.
	useEffect(() => {
		if (isAuth0User) {
			routerPush('/404');
		}
	}, [isAuth0User, routerPush]);

	if (isAuth0User) {
		return null;
	}

	return (
		<Layout pageName="profile">
			<ProfileLayout>
				{appLoaded && !isLoading ? <UpdateUserLayout /> : <Loader color="white" />}
			</ProfileLayout>
		</Layout>
	);
};

export default UpdateUser;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	return {
		props: {
			appHeaderProps: {
				pageTitle: messages.title,
			},
			initialState: {
				...initialState,
				theme: {
					webAppLayout: 'full',
				},
			},
		},
	};
};
